import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useDateFormat from '../../../utils/useDateFormat';
import Chip from '@mui/material/Chip';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { VehicleTransfer, VehicleTransferStatus } from '../../../../../shared/types/vehicle-transfer.types';
import { transferHistoryStyles } from './TransferHistory.styles';

const transferStatusConfig: Record<VehicleTransferStatus, { color: 'warning' | 'success' | 'error' | 'info' }> = {
    pending: { color: 'warning' },
    approved: { color: 'success' },
    rejected: { color: 'error' },
    infoRequested: { color: 'info' },
};

interface TransferHistoryProps {
    transfers: VehicleTransfer[];
}

const TransferHistory: React.FC<TransferHistoryProps> = ({ transfers }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const formatDate = useDateFormat();

    return (
        <TableContainer>
            <Table size="small">
                <TableHead>
                    <TableRow sx={transferHistoryStyles.headerRow}>
                        <TableCell sx={transferHistoryStyles.headerCell}>{t('vehicleDetail.transferHistory.fromOwner')}</TableCell>
                        <TableCell sx={transferHistoryStyles.headerCell}>{t('vehicleDetail.transferHistory.toOwner')}</TableCell>
                        <TableCell sx={transferHistoryStyles.headerCell}>{t('common.status')}</TableCell>
                        <TableCell sx={transferHistoryStyles.headerCell}>{t('common.date')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {transfers.map((transfer) => {
                        const statusCfg = transferStatusConfig[transfer.status ?? 'pending'];
                        return (
                            <TableRow key={transfer.id} hover sx={transferHistoryStyles.clickableRow} onClick={() => navigate(`/app/transfers/${transfer.id}`)}>
                                <TableCell>
                                    <Typography variant="body2">{transfer.fromUserDisplayName ?? '—'}</Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body2">{transfer.toUserDisplayName ?? '—'}</Typography>
                                </TableCell>
                                <TableCell>
                                    <Chip label={t(`vehicleTransferStatus.${transfer.status ?? 'pending'}`)} color={statusCfg.color} size="small" />
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body2">{formatDate(transfer.createdAt)}</Typography>
                                </TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default TransferHistory;
